import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { TextButton } from "@/components/button/text-button";
import { cn } from "@/utils/cn";
import { IonIcon } from "@ionic/react";
import { swapHorizontal, swapHorizontalOutline } from "ionicons/icons";
import { useSwapPlanData } from "../../hooks/use-swap-plan-data";

interface SwapPlanButtonProps {
  meal: Meal;
  mealTime: MealTime;
  mealIndex?: number;
  mealDay?: string;
  targetDate?: string;
  iconOnly?: boolean;
  className?: string;
}

export const SwapPlanButton = ({
  meal,
  mealTime,
  mealIndex,
  mealDay,
  targetDate,
  iconOnly = false,
  className,
}: SwapPlanButtonProps) => {
  const { onSwapClick } = useSwapPlanData();
  if (iconOnly) {
    return (
      <button
        className={cn(
          "flex items-center justify-center rounded-full bg-white p-1 transition-colors hover:bg-gray-100",
          className,
        )}
        onClick={() =>
          onSwapClick({
            meal,
            mealTime,
            mealIndex,
            mealDay,
            targetDate,
          })
        }
      >
        <IonIcon icon={swapHorizontalOutline} className="h-5 w-5 text-gray-900" />
      </button>
    );
  }
  return (
    <TextButton
      className={cn("flex h-12 w-[200px] items-center justify-center gap-2 py-2", className)}
      onClick={() =>
        onSwapClick({
          meal,
          mealTime,
          mealIndex,
          mealDay,
          targetDate,
        })
      }
    >
      <IonIcon icon={swapHorizontal} className="size-5" />
      Swap Meal
    </TextButton>
  );
};
